import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { SiteServices } from '../../services/siteservices';
import {BsDatepickerModule, DatepickerModule, PaginationModule} from 'ngx-bootstrap';
import { TabsModule } from 'ngx-bootstrap';
import { ModalModule } from 'ngx-bootstrap/modal';

import { AlertModule } from 'ngx-bootstrap/alert';
import { RouteReuseStrategy } from '@angular/router';

import { HttpClientModule } from '@angular/common/http';
import { CustomReuseStrategy } from '../common/route.reuse';

import { CorrectionComponent } from './correction.main';

import { MDBBootstrapModule } from 'angular-bootstrap-md';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { EnvironmentServices } from '../../services/evironment.service';

@NgModule({
    declarations: [CorrectionComponent],
    imports: [
        BrowserModule,
        FormsModule,
        HttpModule,
        PaginationModule.forRoot(),
        AlertModule.forRoot(),
        ModalModule.forRoot(),
        HttpClientModule,
        TabsModule.forRoot(),
        MDBBootstrapModule.forRoot(),
        BsDatepickerModule.forRoot(),
        DatepickerModule.forRoot(),
    ],
    providers: [
        SiteServices,
        EnvironmentServices,
        { provide: RouteReuseStrategy, useClass: CustomReuseStrategy },
    ],
    bootstrap: [CorrectionComponent],
})
export class CorrectionModule {}
